import {
    ColoursObj,
    Icon,
    ImageRenderer,
    MainButton,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { useGuestStore } from '../../feat/guest/guest.store'
import i18n from '../../i18n/i18next'
import { Paths } from '../../routes'
import { useBoundStore } from '../../state/bound.store'
import { useRouteGuardContext } from '../../state/routeGuardProvider'
import { useThemeContext } from '../../state/themeState/themeContext'
import { openBrowser } from '../../utils'
import { NoItinerariesContent } from '../homePageInstructions/noItinerariesContent'
import { useGlobalRouter } from '../../feat/globalRouter/useGlobalRouter'
export function EventEndedContent(ended?: any) {
    const { isAllowed } = useRouteGuardContext()
    const { pathname } = useLocation()

    const isGuestMode = useGuestStore((s) => s.isGuestMode)
    if (isGuestMode) return null
    return (
        <Stack gap="8px" alignItems="center">
            <Typography
                color={getContrastYIQ(
                    ColoursObj.backgrounds.primary,
                    ColoursObj.shades.shade1,
                    ColoursObj.shades.shade2
                )}
                align="center"
                id={
                    ended && !isAllowed(['allowedEdit'])
                        ? 'noEditPermission'
                        : 'itineraryEndedSwitchToAnotherTeam'
                }
            >
                {ended && !isAllowed(['allowedEdit'])
                    ? i18n.t('home.no-edit-permission')
                    : i18n.t('home.switch-itinerary-or')}
                {isAllowed(['allowedEdit']) ? (
                    <span style={{ color: ColoursObj.core.secondary }}>
                        {i18n.t(
                            pathname === Paths.team
                                ? 'home.create-is-allowed-team'
                                : 'home.create-is-allowed'
                        )}
                    </span>
                ) : (
                    <span style={{ color: ColoursObj.core.secondary }}>
                        {!ended && i18n.t('home.create-not-allowed')}
                    </span>
                )}
            </Typography>
        </Stack>
    )
}

export default function AddEmptyItinerarySplash() {
    const {
        noItineraries,
        eventEnded,
        itineraryComponents,
        selectedItinEmpty,
    } = useBoundStore(
        useShallow((s) => {
            return {
                noItineraries: s.noItineraries,
                eventEnded: s.eventEnded,
                itineraryComponents: s.itineraryComponents,
                selectedItinEmpty: s.selectedItinEmpty,
            }
        })
    )
    const { isAllowed } = useRouteGuardContext()
    const themeImages = useThemeContext((s) => s.themeImages)
    const isGuestMode = useGuestStore((s) => s.isGuestMode)

    const { pushPath } = useGlobalRouter()
    const [userHasPastEntries, setUserHasPastEntries] = useState(
        Object.keys(itineraryComponents?.past || {}).length !== 0
    )

    useEffect(() => {
        if (itineraryComponents && itineraryComponents.past) {
            setUserHasPastEntries(
                Object.keys(
                    itineraryComponents ? itineraryComponents?.past || {} : {}
                ).length !== 0
            )
        } else {
            setUserHasPastEntries(false)
        }
    }, [itineraryComponents])

    return (
        <Box padding="16px">
            <Stack
                alignItems="center"
                gap="16px"
                justifyContent={noItineraries ? 'center' : 'flex-start'}
            >
                <Typography
                    fontSize={'18px'}
                    variant="bodyBold"
                    color={getContrastYIQ(ColoursObj.backgrounds.primary)}
                    id={
                        noItineraries
                            ? 'welcomeToEventRPageTitle'
                            : eventEnded
                            ? 'itineraryEndedPageTitle'
                            : selectedItinEmpty
                            ? 'itineraryEmptyPageTitle'
                            : ''
                    }
                >
                    {noItineraries
                        ? i18n.t('home.welcome-eventr')
                        : eventEnded
                        ? i18n.t('home.itinerary-ended')
                        : selectedItinEmpty
                        ? i18n.t('home.itinerary-empty')
                        : ''}
                </Typography>
                {!isAllowed(['allowedEdit']) &&
                    isAllowed(['allowedEdit']) !== undefined &&
                    !eventEnded &&
                    !isGuestMode && (
                        <Typography align="center">
                            {i18n.t('home.no-edit-permission')}
                        </Typography>
                    )}
                {noItineraries ? (
                    <ImageRenderer
                        variant="noItins"
                        src={themeImages?.noItins}
                    />
                ) : eventEnded ? (
                    <ImageRenderer
                        variant="eventEnded"
                        src={themeImages?.eventEnded}
                    />
                ) : selectedItinEmpty ? (
                    <ImageRenderer
                        variant="homeEmpty"
                        src={themeImages?.homeEmpty}
                    />
                ) : (
                    ''
                )}
                {eventEnded ? (
                    (itineraryComponents &&
                        itineraryComponents.past &&
                        userHasPastEntries) ||
                    !userHasPastEntries ? (
                        <EventEndedContent ended={eventEnded} />
                    ) : null
                ) : (
                    <>
                        <NoItinerariesContent />
                    </>
                )}
                {eventEnded && !noItineraries && (
                    <MainButton
                        style={{ width: '100%' }}
                        id="linkToPublicItineraries"
                        onClick={() => {
                            openBrowser(
                                'https://eventr.softpauer.com/upcoming-events/'
                            )
                        }}
                        icon={'Leave_App'}
                        iconColour={ColoursObj.shades.shade5}
                        iconPosition="right"
                    >
                        <Typography
                            variant="bodyRegular"
                            color={ColoursObj.shades.shade5}
                        >
                            {i18n.t('account.publicEvents')}
                        </Typography>
                    </MainButton>
                )}
                {noItineraries && isAllowed(['allowedCreateNewItin']) && (
                    <>
                        <MainButton
                            style={{ width: '100%' }}
                            onClick={() => {
                                pushPath(Paths.newItinerary)
                            }}
                            id="newItineraryButton"
                        >
                            <Stack
                                flexDirection={'row'}
                                gap="8px"
                                alignItems={'center'}
                            >
                                <Icon
                                    name="Add"
                                    iconColour={getContrastYIQ(
                                        ColoursObj.core.secondary
                                    )}
                                    height="16px"
                                    width="16px"
                                />
                                <Typography
                                    fontSize={'16px'}
                                    id={'new-itin'}
                                    color={getContrastYIQ(
                                        ColoursObj.core.secondary
                                    )}
                                >
                                    {i18n.t('home.new-itinerary')}
                                </Typography>
                            </Stack>
                        </MainButton>
                        <MainButton
                            style={{ width: '100%' }}
                            id="linkToPublicItineraries"
                            onClick={() => {
                                openBrowser(
                                    'https://eventr.softpauer.com/upcoming-events/'
                                )
                            }}
                            icon={'Leave_App'}
                            iconColour={ColoursObj.shades.shade5}
                            iconPosition="right"
                        >
                            <Typography
                                variant="bodyRegular"
                                color={ColoursObj.shades.shade5}
                            >
                                {i18n.t('account.publicEvents')}
                            </Typography>
                        </MainButton>
                    </>
                )}
            </Stack>
        </Box>
    )
}
